import { useEffect, useRef, useState } from "react";
import './Home.scss';
import { Button, IconButton } from "@mui/material";
import { fn } from "../Functions";
import {Swiper, SwiperClass, SwiperSlide} from "swiper/react";
import {Pagination, Autoplay} from "swiper/modules";

import 'swiper/css';
import 'swiper/css/pagination';


const Root = () => {

    const [titles,] = useState([
        {
            "serviceId": "today", "titleId": "after_dinner",
            "title": "부장님 이 XX 산재처리 되나요?",
            "author": "캐롯타",
            "tags": "BL,리맨물,현대로맨스,완결",
            "episodeCount": 91,
            "thumbnail": "https://static.novela.today/image/after_dinner.jpg",
            "firstEpisodeId": "001",
        },
        {
            "serviceId": "mzfamily", "titleId": "blossoms_in_adversity",
            "title": "석화지",
            "author": "공유(空留) / 보헤미안 X 버프툰",
            "tags": "웹소설,로맨스,완결",
            "episodeCount": 534,
            "thumbnail": "https://static.novela.today/Image/blossomsInAdversity.jpg",
            "firstEpisodeId": "000001",
        },
        {
            "serviceId": "mzfamily", "titleId": "suddenly_pregnant",
            "title": "어느 날, 임신했다",
            "author": "공자연",
            "tags": "웹소설,현대로맨스,완결",
            "episodeCount": 467,
            "thumbnail": "https://static.novela.today/image/suddenly_pregnant.jpg",
            "firstEpisodeId": "000001",
        },
        {
            "serviceId": "today", "titleId": "after_dinner",
            "title": "부장님 이 XX 산재처리 되나요?",
            "author": "캐롯타",
            "tags": "BL,리맨물,현대로맨스,완결",
            "episodeCount": 91,
            "thumbnail": "https://static.novela.today/image/after_dinner.jpg",
            "firstEpisodeId": "001",
        },
        {
            "serviceId": "mzfamily", "titleId": "blossoms_in_adversity",
            "title": "석화지",
            "author": "공유(空留) / 보헤미안 X 버프툰",
            "tags": "웹소설,로맨스,완결",
            "episodeCount": 534,
            "thumbnail": "https://static.novela.today/Image/blossomsInAdversity.jpg",
            "firstEpisodeId": "000001",
        },
        {
            "serviceId": "mzfamily", "titleId": "suddenly_pregnant",
            "title": "어느 날, 임신했다",
            "author": "공자연",
            "tags": "웹소설,현대로맨스,완결",
            "episodeCount": 467,
            "thumbnail": "https://static.novela.today/image/suddenly_pregnant.jpg",
            "firstEpisodeId": "000001",
        },
    ]);
    const [selected, setSelected] = useState<typeof titles[number]>(titles[Math.ceil(titles.length / 2)]);
    const selectWaiter = useRef<ReturnType<typeof setTimeout>>();
    
    useEffect(()=>{

    },[titles]);

    return(<div className={"Home"}>
        <div className={"BG"} style={{backgroundImage: `url(${selected.thumbnail})`, color: 'red'}}></div>
        <div className={"Backdrop"}></div>
        <div className={"TopBar"}>
            <Button
                onClick={fn.gotoByAnchor}
                href={"/"}
            ><img className={"Logo"} src={"https://static.novela.today/icon/Novela.svg"} alt={"logo"}/></Button>
            <IconButton
                onClick={fn.gotoByAnchor}
                href={"/mypage"}
            ><img className={"User"} src={"https://static.novela.today/icon/user-profile-02.svg"} alt={"user"}/></IconButton>
        </div>
        <div className={"MainArea"}>
            <div className={"Hero"}>
                {"드라마 원작 소설을\n정주행권으로 몰아서 즐겨보세요."}
            </div>
            <div className={"Container"}>
                <Swiper
                    className={"SwiperContainer"}
                    direction={"horizontal"}
                    modules={[Pagination, Autoplay]}
                    spaceBetween={3* 16}
                    slidesPerView={2}
                    centeredSlides={true}
                    pagination={{dynamicBullets: true}}
                    onSlideChange={(swiper: SwiperClass) => {
                        if (selectWaiter.current) {
                            clearTimeout(selectWaiter.current);
                        }

                        selectWaiter.current = setTimeout(() => {
                            setSelected(titles[swiper.realIndex]);
                        }, 300);
                    }}
                    loop={true}
                >
                    {titles.map((title, i) => (
                        <SwiperSlide className={"Cell"} style={{width: '14.625rem'}} key={i}>
                            <Button onClick={fn.gotoByAnchor} href={`/contents/${title.serviceId}/${title.titleId}`}>
                                <div className="ButtonContainer">
                                    {<img src={title.thumbnail} alt={title.title}/>}
                                    <div className={"Title"}>{title.title}</div>
                                    <div className={"EpisodeDetail"}>{`${title.episodeCount}화`}</div>
                                    <div className={"Tags"}>{title.tags.split(',').join('·')}</div>
                                    <div className={"Author"}>{title.author}</div>
                                </div>
                            </Button>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
            <Button className={"CTA"} variant={"contained"} disableElevation
                onClick={fn.gotoByAnchor}
                href={`/contents/${selected.serviceId}/${selected.titleId}/${selected.firstEpisodeId}`}
            >{"작품 보기"}</Button>
            <div className={"Dummy"} style={{padding: 16}}></div>
        </div>
    </div>)
}

export default Root;